export const MusterRecruitInviteModalNavigation = Object.freeze({
    SUBMIT: "SUBMIT",
    SUCCESS: "SUCCESS",
});
